module.exports = __webpack_public_path__ + "img/forgot-password.b8e7deb5.png";